import { createContext } from 'react';
import { PopupMessage } from '../types/types';

export interface PopupProps {
  addPopupMessage: (message: PopupMessage) => void;
}

export const PopupMessageContext = createContext<PopupProps>({
  addPopupMessage: () => {},
});
